/**
 * `/reports/programmes/:programmeId` — the read-only report programme
 * viewer. The URL param is `programmeId` per the canonical URL design;
 * `ProgrammeViewer`'s own prop is `libraryId`, a report-domain concept
 * distinct from the platform programme id, so the rename happens only at
 * this route boundary.
 *
 * @module router/reports/ProgrammeViewerRoute
 */

import { useParams } from "react-router";

import { ProgrammeViewer } from "@/components/reports/ProgrammeViewer";

export function ProgrammeViewerRoute() {
  const { programmeId } = useParams<{ programmeId: string }>();
  if (!programmeId) {
    return null;
  }
  return <ProgrammeViewer libraryId={programmeId} />;
}
